import { keycloakUtils } from "itsf-ui-common";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppBar, Badge, Box, SvgIcon, Toolbar, Typography } from "@mui/material";
import { BRAND_NAME, ROUTES, WORDPRESS_URL } from "@constants";
import { useDeviceType } from "@hooks/useDeviceType";
import { useHeader } from "./hook/useHeader";
import { NavigationDesktop } from "./components/NavigationDesktop";
import { useStyle } from "./style";
import logoImg from "@static/img/header/Logo.svg";
import profileDesktopImg from "@static/img/header/Profil.svg";
import cartImg from "@static/img/header/Cart.svg";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";
import { BUTTON_IDS } from "@features/dataLayer/buttonIds";

interface IParams {
    cartItemsNumber?: number;
    logoutCallback?(): void;
}

export const HeaderDesktop = (props: IParams) => {
    const { cartItemsNumber, logoutCallback } = props;
    const { pathname } = useLocation();
    const { t } = useTranslation("header");
    const { isDesktop } = useDeviceType();
    const { classes } = useStyle({ isDesktop });
    const { handleCartClick, handleKeyDown, handleLoginLogout } = useHeader({ logoutCallback });

    return (
        <AppBar className={classes.appBar} position="static">
            <Toolbar className={classes.toolbar} disableGutters>
                <div className={classes.logoContainer}>
                    <a aria-label={t("homePage")} href={WORDPRESS_URL} id={BUTTON_IDS.TOP_NAV.HOME_PAGE_LOGO}>
                        <SvgIcon
                            className={`${classes.logo} ${classes.logoDesktop}`}
                            component={logoImg}
                            viewBox="0 0 80 46"
                        />
                    </a>
                </div>
                <div className={classes.desktopNav}>
                    <NavigationDesktop />
                    <LabeledButton
                        className={classes.myAccountButton}
                        disableFullWidth
                        href={ROUTES.MYACCOUNT_URL}
                        id={BUTTON_IDS.TOP_NAV.MY_GOMO}
                        labelText={t("myAccount", { brand: BRAND_NAME })}
                    >
                        <Typography className={classes.myAccountButtonText} variant="normal">
                            {t("myAccount", { brand: BRAND_NAME })}
                        </Typography>
                    </LabeledButton>
                </div>
                <div className={classes.desktopActionsContainer}>
                    <Box
                        className={classes.loginContainer}
                        id={BUTTON_IDS.TOP_NAV[keycloakUtils.isAuthenticated() ? "LOGOUT" : "LOGIN"]}
                        role="button"
                        tabIndex={0}
                        onClick={handleLoginLogout}
                        onKeyDown={handleKeyDown}
                    >
                        <SvgIcon
                            className={classes.profileDesktopIcon}
                            component={profileDesktopImg}
                            viewBox="0 0 18 18"
                        />
                        <Typography className={classes.loginText} variant="normal">
                            {keycloakUtils.isAuthenticated() ? t("logout") : t("login")}
                        </Typography>
                    </Box>
                    {pathname !== `${ROUTES.CONFIRMATION_PAGE_URL}` && (
                        <Box
                            aria-label={t("cart")}
                            className={classes.cartContainer}
                            id={BUTTON_IDS.TOP_NAV.CART_ICON}
                            role="button"
                            tabIndex={0}
                            onClick={handleCartClick}
                        >
                            <Badge
                                badgeContent={cartItemsNumber}
                                className={classes.badge}
                                invisible={!cartItemsNumber}
                            >
                                <SvgIcon className={classes.cartIconDesktop} component={cartImg} viewBox="0 0 33 30" />
                            </Badge>
                        </Box>
                    )}
                </div>
            </Toolbar>
        </AppBar>
    );
};
